<template>
    <div class="steps-page">
    <section class="section_logo-bar">
    <div class="logonav_wrap">
      <div class="logonav_div">
        <a href="#" class="link-block-73 w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-487"></a>
      </div>
    </div>
  </section>
  <section class="checkout-section steps-main">
    <div class="checkoutb_wrap-4">
      <div class="checkoutb_div">
        <div class="almostdone-div">
          <div class="text-block-1457">Almost Done {{user.first_name}}!</div>
          <div class="text-block-1458">Our 100% digital process will ensure you can start your medical weightloss journey and start in as little as 2 Days.</div>
          <div class="timeline-div-2">
            <div class="linebullet_div-2"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-591">
              <div>
                <div class="text-block-1460">5-10 minutes</div>
                <div class="text-block-1459">Complete Medical Questionnaire</div>
                <div class="text-block-1456">Fill out a short online form to submit to the doctor.</div>
              </div>
            </div><img loading="lazy" src="@/assets/images/icon_arrowdown.svg" alt="" class="image-592">
            <div class="linebullet_div-2"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-591">
              <div>
                <div class="text-block-1460">24 Hours or Less</div>
                <div class="text-block-1459">Doctor Review &amp; Prescription</div>
                <div class="text-block-1456">Most patients do not require a video doctor visit. If approved you will receive an instant notification.</div>
              </div>
            </div><img loading="lazy" src="@/assets/images/icon_arrowdown.svg" alt="" class="image-592">
            <div class="linebullet_div-2"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-591">
              <div>
                <div class="text-block-1460">Same Day Processing</div>
                <div class="text-block-1459">Our Pharmacy Processes Your Order</div>
                <div class="text-block-1456">Our US Based, FDA Approved Pharmacies process your order same day if before 3 (Mon-Thursday)</div>
              </div>
            </div><img loading="lazy" src="@/assets/images/icon_arrowdown.svg" alt="" class="image-592">
            <div class="linebullet_div-2"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-591">
              <div>
                <div class="text-block-1460">48 Hours or Less</div>
                <div class="text-block-1459">FREE 2 Day Express Shipping</div>
                <div class="text-block-1456">You can track the packages and get updates directly in our portal.</div>
              </div>
            </div>
          </div>
          <div class="almost-button-div">
            <a href="#" class="button-137 w-button" @click="pushToMedForm()">Complete Medical Form <span class="text-span-330">-&gt;</span></a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TrustPilot footer (sticky to bottom of viewport on short content) -->
  <div class="trust-pilot-div steps-footer">
    <img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
    <div class="flow-rating-div">
      <div class="text-block-1723">Excellent</div>
      <div class="text-block-1724">4.6 out of 5</div>
      <img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/683486885685e2905f4c45af_Trustpilot_Logo_(2022).svg.webp" loading="lazy" alt="Trustpilot" class="image-690">
    </div>
    <div>Trusted by thousands of members</div>
  </div>
    </div>
    </template>
    <script>
    
    import { mapGetters } from 'vuex';
    export default {
        name: 'paymentThanks',
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                active_el: 1,
                selectedOption:'',
                submitting: false,
            }
        },
        computed:{
            ...mapGetters(['getRemainingPrescriptions','user']),
            remainingPrescriptions() {
                return this.getRemainingPrescriptions;
            },
            getDrugName(){
                return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
            },
            getProductName(){
                return JSON.parse(localStorage.getItem("planName"))
            }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods:{
         
            setMedSelected(value){
                this.selectedOption = value;
                this.moveToNext();
            },
            moveToNext(){
                this.active_el=2;
            },
            async sendRequest(product){
              let response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                  selectedMed: product
              });
              return response;
            },
            async addBundleAndMove(){
                this.submitting = true;
                if(this.selectedOption!=''){
                    let response = await this.sendRequest(this.selectedOption);
                    console.log(response)
                    this.active_el=3;
                }else{
                  let response = await this.sendRequest("None");
                  console.log(response)
                  this.active_el=3;
                }
                
            },
            pushToMedForm(){
              this.$router.push({
                  name: 'verifyPhoneAndEmail'
              });
            }
        },
        mounted(){
            console.log(this.remainingPrescriptions)
            
        }
    }
    </script>
    <style scoped>
    /* Sticky-footer: #app is already `display: flex; flex-direction: column; min-height: 100vh`.
       Giving .steps-page `flex: 1` makes it fill remaining viewport space, which pushes the
       global teal site footer (rendered after router-view in App.vue) down to the bottom of
       the viewport. When content grows tall, this naturally lets the browser scroll. */
    .steps-page {
        flex: 1;
        background-color: var(--f6-grey, #f6f6f6);
    }
    .section_logo-bar {
        background-color: #fff;
    }
    .steps-main {
        background-color: var(--f6-grey, #f6f6f6);
    }
    .steps-main .checkoutb_wrap-4 {
        padding-bottom: 24px;
    }
    .steps-footer {
        background-color: var(--f6-grey, #f6f6f6);
        padding: 8px 16px 24px;
    }

    .selected-plan-img{
        width: 45px;
    }
    </style>